import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  if (authService.isTokenExpired()) {
    authService.logout();
    return router.createUrlTree(['/login']);
  }

  if (authService.mustChangePassword() && state.url !== '/trocar-senha') {
    return router.createUrlTree(['/trocar-senha']);
  }

  return true;
};
